import { GET, POST } from '../common/common.service'
import { endpointsSpainFuelStations } from './endpoints'

export const SpainFuelStationsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsSpainFuelStations.LOAD(filter, sort, limit, skip)),
  updateFuelStationSpain: async () =>
    POST(endpointsSpainFuelStations.FUEL_STATIONS),
  getPriceMinetur: async (id) =>
    GET(endpointsSpainFuelStations.PRICE_MINETUR(id)),
}
